import {v4 as uuidv4} from 'uuid'




export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}


export function firstYearDay(year) {
	return new Date(`${year}-01-01T00:00:00.000Z`)
}

export function lastYearDay(year) {
	return new Date(`${year}-12-31T00:00:00.000Z`)
}

export function dayStart(date) {
	const tmp = new Date(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}T00:00:00.000Z`)
	tmp.setHours(0)
	return tmp
}

export function dayEnd(date) {
	const tmp = new Date(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}T23:59:59.999Z`)
	tmp.setHours(23)
	return tmp
}


export function calculateTimeWindows(timeFrom, timeTo) {
	let influxDbPeriod
	let windowDuration
	let windows = []
	const ONE_HOUR = 1000 * 60 * 60
	const ONE_DAY = 1000 * 60 * 60 * 24
	// const ONE_MONTH = 1000 * 60 * 60 * 24 * 31
	const ONE_YEAR = 1000 * 60 * 60 * 24 * 365
	const duration = timeTo.getTime() - timeFrom.getTime()
	if (duration / ONE_HOUR <= 6) {
		influxDbPeriod = '1m'
		windowDuration = 1000 * 60
	} else if (duration / ONE_DAY <= 2) {
		influxDbPeriod = '10m'
		windowDuration = 1000 * 60 * 10
	} else if (duration / ONE_DAY <= 8) {
		influxDbPeriod = '1h'
		windowDuration = 1000 * 60 * 60
	} else if (duration / ONE_DAY <= 31) {
		influxDbPeriod = '4h'
		windowDuration = 1000 * 60 * 60 * 4
	} else if (duration / ONE_DAY <= 367) {
		influxDbPeriod = '1d'
		windowDuration = 1000 * 60 * 60 * 24
	} else if (duration / ONE_YEAR <= 3) {
		influxDbPeriod = '7d'
		windowDuration = 1000 * 60 * 60 * 24 * 7
	} else {
		influxDbPeriod = '30d'
		windowDuration = 1000 * 60 * 60 * 24 * 30
	}

	// Calculate windows
	for (let start = timeFrom.getTime(); start <= timeTo.getTime(); start += windowDuration) {
		const end =  start + windowDuration
		windows.push([new Date(start), new Date(end)])
	}

	return {
		influxDbPeriod,
		windows,
	}
}


// Substract from now date "years". Return Date Object
export function subtractYearsFromNowDate(years) {
	const timeNow = new Date().getTime()
	return new Date(timeNow - (years * 365 * 24 * 3600 * 1000))
}

// Substract from now date "days". Return Date Object
export function subtractDaysFromNowDate(days) {
	const timeNow = new Date().getTime()
	return new Date(timeNow - (days * 24 * 3600 * 1000))
}

// Substract from now date "hours". Return Date Object
export function subtractHoursFromNowDate(hours) {
	const timeNow = new Date().getTime()
	return new Date(timeNow - (hours * 3600 * 1000))
}

// Substract from now date "minutes". Return Date Object
export function subtractMinutesFromNowDate(minutes) {
	const timeNow = new Date().getTime()
	return new Date(timeNow - (minutes * 60 * 1000))
}

// Add seconds to date. Return Date Object
export function addSecondsToDate(date, seconds) {
	return new Date(date.getTime() + seconds * 1000)
}




// Return formated date string YYYY-MM-DD
export function dateTimeToDateString(date) {
	return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
}

// Return formated date string hh:mm:ss
export function dateTimeToTimeString(date) {
	return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`
}



// Return formated time string hh:mm
export function chartTimeStr(date, isSeconds = false) {
	return `${date.getHours().toString().padStart(2, '0')}`
		+ `:${date.getMinutes().toString().padStart(2, '0')}`
		+ (isSeconds ? `:${date.getSeconds().toString().padStart(2, '0')}` : '')
}



// Return formated date string DD.MM.YYYY
export function chartDateStr(date) {
	return `${date.getDate().toString().padStart(2, '0')}`
		+`.${(date.getMonth()+1).toString().padStart(2, '0')}`
		+ `.${date.getFullYear().toString().padStart(2, '0')}`
}



// Return formated date string DD.MM.YYYY hh:mm:ss
export function dateTimeToString(dt, applyTimezoneOffset=true, withMilliseconds=false, withSeconds=false) {
	let offset = dt.getTimezoneOffset() * 60000
	if (!applyTimezoneOffset) {
		offset = 0
	}
	var local = new Date(dt.getTime() + offset);
	try {
		return `${local.getDate().toString().padStart(2, '0')}`
			+`.${(local.getMonth()+1).toString().padStart(2, '0')}`
			+ `.${local.getFullYear().toString().padStart(2, '0')}`
			+ String.fromCharCode(160)
			+ `${local.getHours().toString().padStart(2, '0')}`
			+ `:${local.getMinutes().toString().padStart(2, '0')}`
			+ (withSeconds ? `:${local.getSeconds().toString().padStart(2, '0')}` : '')
			+ (withMilliseconds ? `.${local.getMilliseconds().toString().padStart(3, '0')}` : '')
	} catch (error) {
		return "-"
	}
}




// Returns string in RFC3339
// 2262-04-11T23:47:16.854775806Z
export function dateTimeToRFC3339(dt) {
	var utc = new Date(dt.getTime() + dt.getTimezoneOffset() * 60000);

	try {
		return `${utc.getFullYear().toString().padStart(2, '0')}`
			+ `-${(utc.getMonth()+1).toString().padStart(2, '0')}`
			+ `-${utc.getDate().toString().padStart(2, '0')}`
			+ `T${utc.getHours().toString().padStart(2, '0')}`
			+ `:${utc.getMinutes().toString().padStart(2, '0')}`
			+ `:${utc.getSeconds().toString().padStart(2, '0')}`
			+ `.${utc.getUTCMilliseconds().toString()}Z`
	} catch (error) {
		return "-"
	}
}




// Returns string in Local date and time strings.
// YYYY-MM-DDThh:mm
export function dateTimeLocalString(date) {
	const year = date.getFullYear()
	const month = (date.getMonth() + 1).toString().padStart(2, "0")
	const day = date.getDate().toString().padStart(2, "0")
	const hours = date.getHours().toString().padStart(2, "0")
	const minutes = date.getMinutes().toString().padStart(2, "0")

	return `${year}-${month}-${day}T${hours}:${minutes}`
}




// Returns string in Local date and time strings.
// YYYY-MM-DDThh:mm
export function dateLocalString(date) {
	const year = date.getFullYear()
	const month = (date.getMonth() + 1).toString().padStart(2, "0")
	const day = date.getDate().toString().padStart(2, "0")

	return `${year}-${month}-${day}`
}




// Returns time from now text promt
// time: Date()
export function timeFromNowPromt(time) {
	const period = timeFromNowS(time)
	return period ? verboseTimePeriod(period) : '-'
}


//
export function timeFromNowS(time) {
	try {
		if (time === undefined) {
			return undefined
		}

		return Math.round(((new Date().getTime() - time.getTime()) / 1000))
	} catch (error) {
		return undefined
	}
}


// Returns verbose time period
// periodSeconds: seconds
export function verboseTimePeriod(periodSeconds, isPrecisely=false) {
	const getWholePart = (periodSeconds) => {
		let divider = 1
		let unitName = ''
		if (periodSeconds < 60) {
			divider = 1
			unitName = 'c'
		} else if (periodSeconds >= 60 && periodSeconds < (60*60)) {
			divider = 60
			unitName = 'хв'
		} else if (periodSeconds >= 3600 && periodSeconds < (60*60*24)) {
			divider = 3600
			unitName = 'год'
		} else if (periodSeconds >= (60*60*24) && periodSeconds < (60*60*24*7)) {
			divider = 60 * 60 * 24
			unitName = 'д'
		} else if (periodSeconds >= (60*60*24*7) && periodSeconds < (60*60*24*7*4)) {
			divider = 60 * 60 * 24 * 7
			unitName = 'тиж'
		} else if (periodSeconds >= (60*60*24*7*4) && periodSeconds < (60*60*24*365)) {
			divider = 60 * 60 * 24 * 7 * 4
			unitName = 'міс'
		} else if (periodSeconds >= (60*60*24*365)) {
			divider = 60 * 60 * 24 * 365
			unitName = 'р'
		}

		const periodInt = Math.trunc(periodSeconds / divider)
		const periodQuotient = periodSeconds % divider

		return {
			divider,
			unitName,
			periodInt,
			periodQuotient,
		}
	}

	let iteration = getWholePart(periodSeconds)

	if (isPrecisely) {
		let promt = ''

		for (let i = 0; i < 10; i++) {
			promt += `${iteration.periodInt} ${iteration.unitName}, `
			iteration = getWholePart(iteration.periodQuotient)
			if (iteration.divider == 1) {
				if (iteration.periodInt > 0) {
					promt += `${iteration.periodInt} ${iteration.unitName}`
				} else {
					promt = promt.slice(0, -2)
				}
				break
			}
		}

		return promt
	} else {
		return `${iteration.periodInt} ${iteration.unitName}`
	}


}


// Returns period in days
export function periodDays(timeFrom, timeTo) {
	return (timeTo - timeFrom) / (1000.0 * 60 * 60 * 24)
}

// Returns period in days
export function periodHours(timeFrom, timeTo) {
	return (timeTo - timeFrom) / (1000.0 * 60 * 60)
}


/* Returns differense date1 - date2 in days and hours */
export function timeDiffString(date1, date2 = new Date()) {
	if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
		return ''
	}

	let diff = date2.getTime() - date1.getTime();

	const days = Math.floor(diff / (1000 * 60 * 60 * 24));
	diff -=  days * (1000 * 60 * 60 * 24);

	const hours = Math.floor(diff / (1000 * 60 * 60));
	diff -= hours * (1000 * 60 * 60);

	return `${days}д ${hours}г`
}




/*
*/
export function createUuidv4() {
	// Generate a random UUID 
	const random_uuid = uuidv4(); 
	//console.log("UUID", random_uuid)
	return random_uuid
}




/* */
export function truncateIfFloat(val, digits=2) {
	if (Number.isInteger(val) && val % 1 > 0) {
		return val.toFixed(digits)
	} else {
		return val
	}
}


/* */
export function fixNumberPrecision(val, precision=2) {
	if (typeof val === "number") {
		return val.toFixed(precision)
	} else if (val === null || val === undefined) {
		return "-"
	} else {
		return val
	}
}


/* */
export function numberToKnumber(val, precision=2) {
	if (typeof val === "number") {
		return (val / 1000).toFixed(precision)
	} else if (val === null || val === undefined) {
		return "-"
	} else {
		return val
	}
}




/* */
export function connectionColor(state) {
	switch(state) {
		case true:
			return 'rgb(115, 191, 105)'
		case false:
			return 'rgb(242, 73, 92)'
		default: 
			return 'rgb(95, 99, 104)'
	}
}




/* Make easy-data-table height calculation */
export function easyDataTableHeight(withFooter=true) {
	const	body = document.body,
			html = document.documentElement;
	const	docHeight = Math.max(
		body.scrollHeight,
		body.offsetHeight, 
		html.clientHeight,
		html.scrollHeight,
		html.offsetHeight
	)
	const footerHeight = withFooter ? 36 : 0
	const headerHeight = 48 // adjust
	const tableHeight = docHeight - headerHeight - footerHeight - 64

	return tableHeight
}




/* Make easy-data-table rows per page calculation */
export function easyDataTableRowsPerPage(tableHeight=null, rowHeight=38) {
	const actualHeight = tableHeight == null ? easyDataTableHeight() : tableHeight
	return Math.floor(actualHeight / rowHeight)
}




/* Compare two arrays element by element */
export function compareArrays(a, b) {
	if (a.length !== b.length) {
		return false
	} else {
		a.sort()
		b.sort()

		// Comparing each element of array
		for (var i = 0; i < a.length; i++) {
			if (a[i] !== b[i]) {
				return false
			}
		}

		return true
	}
}



/* Build calendar */
export function buildCalendar(period, startTimeString) {
	const SECONDS_IN_DAY = 86400
	let calendar = []
	let startTime = new Date()
	let endTime = new Date()

	startTime.setHours(0, 0, 0, 0)
	endTime.setHours(23, 59, 59, 999)

	if (isNaN(period)) {
		return calendar
	// If day calendar
	} else if (period <= SECONDS_IN_DAY) {
		// Iterate timepoints
		for (let i = startTime; i <= endTime; i.setTime(i.getTime() + period * 1000)) {
			calendar.push(dateTimeToTimeString(i))
		}
	// If year calendar
	} else {
		startTime.setFullYear(startTime.getFullYear(), 0, 1)
		endTime.setFullYear(startTime.getFullYear(), 11, 31)

		if (startTimeString) {
			startTime.setHours(startTimeString?.slice(0,2), startTimeString?.slice(3,5), startTimeString?.slice(6,8), 0)
		}

		// Iterate timepoints
		for (let i = startTime; i <= endTime; i.setTime(i.getTime() + period * 1000)) {
			calendar.push(dateTimeToString(i, false, false, true))
		}
	}

	return calendar
}




/* Compare two objects.
Returns null when objects are identical.
Returns new object with changes if not indentical.
https://dev.to/digitaldrreamer/how-to-compare-diff-two-objects-2ocd
*/
export function getObjectDiff(original, current) {
	const changes = {}

	// Check current object's properties
	for (const [key, value] of Object.entries(current)) {
		if (!(key in original) && current[key] !== undefined) {
			changes[key] = {
				oldValue: undefined,
				newValue: value
			}
			continue
		}

		const originalValue = original[key]
		const currentValue = value

		// Handle different types of comparisons
		if (
			originalValue !== currentValue &&
			String(originalValue) !== String(currentValue) &&
			JSON.stringify(originalValue) !== JSON.stringify(currentValue)
		) {
			changes[key] = {
				oldValue: originalValue,
				newValue: currentValue
			}
		}
	}
	
	// Check for removed properties
	for (const key of Object.keys(original)) {
		if (!(key in current)) {
			changes[key] = {
				oldValue: original[key],
				newValue: undefined
			}
		}
	}

	return Object.keys(changes).length === 0 ? null : changes
}
